<template>
    <v-row class="mx-2 pa-0 option" align="center" justify="center" >
        <span
        :class="`primary--text font-weight-bold px-3 w-100 ${isInitialReader ? 'text-subtitle-1 ': 'text-body-1'}`"
        v-if="isReading"
      >
        {{ answer.content }}
      </span>
        <v-col
            data-cy="questionItem-item-selection"
            cols="12"
            :key="'radio-' + question.id + '-' + answer.id"
            :id="answer.id"
            :style="{background:`url(${answer.image}) no-repeat center`, backgroundSize: 'cover'}"
            v-ripple
            :class="styles"
            @click="setSelectedBtn"
            elevation="0"
        >
            <v-icon
                :class="`white rounded-circle position-absolute check transition-all ${selected ? 'primary--text': 'white--text'}`">
                {{check}}
            </v-icon>
        </v-col>
        <v-col cols="12" :class="`d-flex justify-center`">
            <v-img
                src="/img/user/soundicon.svg"
                max-height="45px"
                max-width="45px"
                contain
                class="main-sound-img cursor-pointer"
                @click="readText(isReading ? answer.content : answer.contenido)"
            ></v-img>
        </v-col>
    </v-row>
</template>

<script>
    import SpeechSynthesis from "../../../../mixins/SpeechSynthesis";
    import initialReaderValidation from "../../../../mixins/InitialReaderValidation";
    import {mapState} from "vuex";

    export default {
        name: "ImageOption",
        props: {
            answer: {type: Object, default: () => ({})},
            question: {type: Object, default: () => ({})},
            selected: {type: Boolean, default: () => ({})},
            isReading: {type: Boolean, default: () => false},
        },
        computed: {
            ...mapState({
                course: (state) => state.userData.user.course,
            }),
            styles() {
                return `alternative-image rounded-lg position-relative option-img ma-2 overflow-hidden transition-all cursor-pointer pa-0 border-radius-1 text-none option-btn
                ${this.selected ? 'primary white--text' : 'white primary--text'}`
            },
            check() {
                return this.selected ? 'mdi-check-circle' : 'mdi-checkbox-blank-circle'
            },
        },

        data() {
            return {
                btnSelected: {
                    id: null,
                    value: null,
                    secret: null,
                },
            }
        },
        methods: {
            setSelectedBtn() {
                this.$emit('select', {
                    id: this.answer.id,
                    value: this.answer.id,
                    secret: this.answer.item,
                })
            },
        },
        mixins: [SpeechSynthesis, initialReaderValidation],
    }
</script>

<style scoped>
    .option-img {
        max-width: 180px;
        height: 180px;
        display: block;
        box-sizing: border-box;
    }

    .check {
        top: 1vh;
        right: 1vh;
    }



</style>
